<template>
  <a-layout :style="{background:'#f1f3f3',minHeight:'100vh'}">
    <a-layout-content>
      <a-row>
        <a-col type="flex" justify="space-around" align="middle" class="wemail-login-box">
          <img src="@/assets/wemail.svg" alt class="we__logo">
        </a-col>
      </a-row>
      <a-row>
        <a-col type="flex" justify="space-around" align="middle" :style="{fontSize: '1.2em', margin: '20px', fontWeight: 'bold', textTransform: 'uppercase'}">
          Login to weMail management portal
        </a-col>
      </a-row>
      <a-row type="flex" justify="space-around" align="middle">
        <a-col :span="8">
          <a-form
            id="components-form-demo-normal-login"
            :form="form"
            class="login-form height-50"
            @submit="handleSubmit"
          >
            <a-form-item v-if="errors.root">
              <a-alert :message="errors.root" type="error" showIcon />
            </a-form-item>
            <a-form-item :validate-status="errors.email ? 'error' : 'validating'" :help="emailValidationMsg">
              <a-input placeholder="Email" v-model="user.email">
                <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
              </a-input>
            </a-form-item>
            <a-form-item :validate-status="errors.password ? 'error' : 'validating'" :help="passwordValidationMsg">
              <a-input type="password" placeholder="Password" v-model="user.password">
                <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-checkbox>Remember me</a-checkbox>
              <router-link tag="a" :to="{name: 'password.forget'}" class="login-form-forgot">
                Forgotten your password?
              </router-link>
              <a-button type="primary" html-type="submit" class="login-form-button">Log in</a-button>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { mapActions } from 'vuex';
import localforage from 'localforage';

export default {
  data() {
    return {
      errors: {},
      user: {
        email: '',
        password: ''
      }
    }
  },
  computed: {
    emailValidationMsg() {
      if (this.errors.email) return this.errors.email[0];
      return '';
    },
    passwordValidationMsg() {
      if (this.errors.password) return this.errors.password[0];
      return '';
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    ...mapActions ({
        login: 'auth/login',
        logout: 'auth/logout'
    }),
    handleSubmit(e) {
      e.preventDefault();
      this.login({
          payload: { email: this.user.email, password: this.user.password },
          context: this
      }).then((res) => {
          // localforage.getItem('intended', (err, value) => {
          //   this.$router.replace(value);
          //   localforage.removeItem('intended');
          //   return;
          // });
          this.$router.replace({ name: 'admin.dashboard' });
      });
    }
  },
  created() {
    localforage.getItem('alert').then((item) => {
      if (item != null && item.hasOwnProperty('type') && item.hasOwnProperty('msg')) {
        this.$weNotify(item.type, item.msg);
      }
      localforage.removeItem('alert');
    });
  }
};
</script>
<style scoped>
.body {
  width: 100%;
}
.we__logo {
  height: 80px;
  width: 80px;
}
.wemail-login-box {
  margin-top: 10%;
}
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
</style>
